export default __webpack_public_path__ + "3c3264745a43e4eb1d80c872d7ec7c27.png";